module.exports = __webpack_public_path__ + "img/timer-sand-full.9f2e3184.svg";